import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '../../../../../common/checkbox';

const AccountInfoHeader = ({
    isBalanceVisible,
    checkboxIconType,
    onToggleBalanceVisibility,
    onLogoutClick,
}) => (
    <div className="bs-account__tabHeader">
        <Checkbox
            name="ShowBalance"
            checked={isBalanceVisible}
            onSelect={onToggleBalanceVisibility}
            className="bs-accountInfo__balance"
            iconType={checkboxIconType}
            iconSize="Large"
        >
            <span className="bs-link bs-accountInfo__balanceLabel">
                {isBalanceVisible ? 'Hide Balance' : 'Show Balance'}
            </span>
        </Checkbox>
        <button
            className="bs-btn bs-btn_hollow bs-accountInfo__logout"
            onClick={onLogoutClick}
        >
            <span>Sign Out</span>
        </button>
    </div>
);

AccountInfoHeader.propTypes = {
    isBalanceVisible: PropTypes.bool.isRequired,
    checkboxIconType: PropTypes.string.isRequired,
    onToggleBalanceVisibility: PropTypes.func.isRequired,
    onLogoutClick: PropTypes.func.isRequired,
};

export default AccountInfoHeader;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/accountInfo/components/AccountInfoHeader.jsx